export default __webpack_public_path__ + "static/media/icon_dashboard.fce76e8c.svg";